import { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface AiImageComparisonDialogProps {
  isOpen: boolean;
  originalUrl: string;
  optimizedUrl: string;
  isApproving: boolean;
  onApprove: () => void;
  onClose: () => void;
}

export const AiImageComparisonDialog: FC<AiImageComparisonDialogProps> = ({
  isOpen,
  originalUrl,
  optimizedUrl,
  isApproving,
  onApprove,
  onClose,
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => !open && !isApproving && onClose()}
    >
      <DialogContent
        showCloseButton={!isApproving}
        className="max-w-5xl w-full"
      >
        <DialogHeader>
          <DialogTitle>Comparar imagens</DialogTitle>
          <DialogDescription className="sr-only">
            Compare a imagem original com a versão otimizada pela IA e aprove
            com a otimizada ou feche para voltar sem aprovar.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-gray-700 text-center">
              Original proposta
            </p>
            <div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
              <img
                src={originalUrl}
                alt="Imagem original proposta"
                className="w-full h-full object-contain"
                onError={(e) =>
                  ((e.currentTarget as HTMLImageElement).style.display = "none")
                }
              />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-gray-700 text-center">
              Versão otimizada
            </p>
            <div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
              <img
                src={optimizedUrl}
                alt="Imagem otimizada pela IA"
                className="w-full h-full object-contain"
                onError={(e) =>
                  ((e.currentTarget as HTMLImageElement).style.display = "none")
                }
              />
            </div>
          </div>
        </div>

        <DialogFooter className="flex gap-2 sm:justify-end">
          <Button variant="outline" onClick={onClose} disabled={isApproving}>
            Fechar
          </Button>
          <Button
            onClick={onApprove}
            loading={isApproving}
            disabled={isApproving}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            Aprovar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
